module.exports = __webpack_public_path__ + "img/refer-client-1.abd2bf90.svg";